// Currency helper for ErasmusSwap.
// Used everywhere a price is displayed or chosen.

export const CURRENCY_OPTIONS = [
    { code: "EUR", symbol: "€", label: "Euro (€)" },
    { code: "GBP", symbol: "£", label: "British Pound (£)" },
    { code: "USD", symbol: "$", label: "US Dollar ($)" },
    { code: "CHF", symbol: "CHF", label: "Swiss Franc (CHF)" },
    { code: "SEK", symbol: "kr", label: "Swedish Krona (kr)" },
    { code: "NOK", symbol: "kr", label: "Norwegian Krone (kr)" },
    { code: "DKK", symbol: "kr", label: "Danish Krone (kr)" },
    { code: "PLN", symbol: "zł", label: "Polish Złoty (zł)" },
    { code: "CZK", symbol: "Kč", label: "Czech Koruna (Kč)" },
    { code: "HUF", symbol: "Ft", label: "Hungarian Forint (Ft)" },
    { code: "RON", symbol: "lei", label: "Romanian Leu (lei)" },
    { code: "BGN", symbol: "лв", label: "Bulgarian Lev (лв)" },
    { code: "TRY", symbol: "₺", label: "Turkish Lira (₺)" },
    { code: "JPY", symbol: "¥", label: "Japanese Yen (¥)" },
    { code: "CAD", symbol: "CA$", label: "Canadian Dollar (CA$)" },
    { code: "AUD", symbol: "A$", label: "Australian Dollar (A$)" },
];

const SYMBOL_BY_CODE = Object.fromEntries(CURRENCY_OPTIONS.map((c) => [c.code, c.symbol]));

const PREFIX_CODES = new Set(["EUR", "GBP", "USD", "CHF", "CAD", "AUD", "JPY", "TRY"]);

export function currencySymbol(code) {
    return SYMBOL_BY_CODE[code] || code || "€";
}

export function formatPrice(amount, code = "EUR", { perMonth = false } = {}) {
    if (amount === undefined || amount === null || isNaN(Number(amount))) return "";
    const sym = currencySymbol(code);
    const value = Math.round(Number(amount)).toLocaleString("en-US");
    const formatted = PREFIX_CODES.has(code) ? `${sym}${value}` : `${value} ${sym}`;
    return perMonth ? `${formatted} / mo` : formatted;
}
